//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features/index';

import { ICuralateStore } from '@models/AppState';

export const createHasFeatureSelector =
  (featureName: FeatureNames) => (state: ICuralateStore) =>
    !!state.session.features[featureName];
